import { isDefined } from './util';
import global from './global';
export const renderAstroEventTime = (astroClock, index, key) => {
    const event = astroClock[index];
    if (!isDefined(event)) {
        return global.NOT_AVAILABLE;
    }
    const eventTime = event[key];
    if (!isDefined(eventTime)) {
        return global.NOT_AVAILABLE;
    }
    return eventTime.slice(0, 5);
};
